import { DATE_VALUES, getRangeFromDateFilter } from 'utils/dateUtils'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { createIncidentErrorCodes } from '../ThreatLog/constants'

import {
  CREATE_ATO_INCIDENT_ASYNC,
  FETCH_DATA_ASYNC,
  FETCH_DEPARTMENTS_ASYNC,
  LICENSE_DATA_REQUEST_ASYNC,
  RESET_ALL_FILTERS,
  RESET_SELECTED_ADDONS,
  SET_ALERT_ID,
  SET_ARRIVAL_DATE,
  SET_DEPARTMENT,
  SET_EMAIL_ADDRESS,
  SET_PAGE_NUMBER,
  TOGGLE_ADDON_TO_UNLOCK,
} from './constants'

const PROFILES_PAGE_SIZE = 10
const INITIAL_PAGE = 1
const INITIAL_ARRIVAL_DATE_VALUE = DATE_VALUES.WEEK

const initialState = {
  data: [],
  loader: false,
  error: null,
  permissionsError: false,
  noAddonsError: false,
  departments: [],
  departmentsLoader: false,
  arrivalDate: INITIAL_ARRIVAL_DATE_VALUE,
  pageNumber: INITIAL_PAGE,
  pageSize: PROFILES_PAGE_SIZE,
  totalPages: 1,
  selectedDepartment: '',
  emailAddress: '',
  license: {},
  selectedAddonsToUnlock: [],
  licenseLoader: false,
  alertId: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS:
      return {
        ...initialState,
        loader: true,
        departmentsLoader: true,
        licenseLoader: true,
      }
    case FETCH_DATA_ASYNC.INITIATE: {
      return {
        ...state,
        data: [],
        loader: true,
        error: null,
        permissionsError: false,
        noAddonsError: false,
      }
    }
    case FETCH_DATA_ASYNC.SUCCESS: {
      return {
        ...state,
        data: action.payload.data.data,
        loader: false,
        error: null,
        totalPages: action.payload.data.total_pages,
      }
    }
    case FETCH_DATA_ASYNC.ERROR: {
      if (
        action.payload.status === 400 &&
        action.payload.response.message.includes('ATO disabled')
      ) {
        return {
          ...state,
          loader: false,
          noAddonsError: true,
        }
      }
      if (action.payload.status === 403) {
        return {
          ...state,
          loader: false,
          permissionsError: true,
        }
      }
      return {
        ...state,
        loader: false,
        error: action.payload,
      }
    }
    case FETCH_DATA_ASYNC.CANCEL: {
      return {
        ...state,
        loader: false,
      }
    }
    case FETCH_DEPARTMENTS_ASYNC.INITIATE: {
      return {
        ...state,
        departments: [],
        departmentsLoader: true,
        error: null,
      }
    }
    case FETCH_DEPARTMENTS_ASYNC.SUCCESS: {
      return {
        ...state,
        departments: action.payload.data.map((elem) => ({
          label: elem,
          value: elem,
        })),
        departmentsLoader: false,
      }
    }
    case FETCH_DEPARTMENTS_ASYNC.ERROR: {
      return {
        ...state,
        departmentsLoader: false,
        error: action.payload,
      }
    }
    case FETCH_DEPARTMENTS_ASYNC.CANCEL: {
      return {
        ...state,
        departmentsLoader: false,
      }
    }
    case SET_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload.page,
        data: [],
        loader: true,
        error: null,
      }
    case SET_ARRIVAL_DATE:
      return {
        ...state,
        arrivalDate: action.payload.arrivalDate,
        feDateRange: getRangeFromDateFilter(action.payload.arrivalDate),
        pageNumber: INITIAL_PAGE,
        data: [],
        loader: true,
        error: null,
      }
    case SET_DEPARTMENT:
      return {
        ...state,
        selectedDepartment: action.payload.department,
        pageNumber: INITIAL_PAGE,
        data: [],
        loader: true,
        error: null,
      }
    case SET_EMAIL_ADDRESS:
      return {
        ...state,
        emailAddress: action.payload.emailAddress,
        pageNumber: INITIAL_PAGE,
        // no need for "loader: true" here
      }
    case RESET_ALL_FILTERS:
      return {
        ...state,
        arrivalDate: INITIAL_ARRIVAL_DATE_VALUE,
        feDateRange: getRangeFromDateFilter(INITIAL_ARRIVAL_DATE_VALUE),
        pageNumber: INITIAL_PAGE,
        selectedDepartment: '',
        emailAddress: '',
        loader: true,
      }

    case LICENSE_DATA_REQUEST_ASYNC.INITIATE:
      return {
        ...state,
        licenseLoader: true,
      }
    case LICENSE_DATA_REQUEST_ASYNC.SUCCESS: {
      return {
        ...state,
        error: null,
        license: { ...action.payload.data },
        licenseLoader: false,
      }
    }
    case LICENSE_DATA_REQUEST_ASYNC.ERROR:
      if (action.payload.status === 400 || action.payload.status === 403) {
        return {
          ...state,
          licenseLoader: false,
          permissionsError: true,
        }
      }
      return {
        ...state,
        licenseLoader: false,
        error: action.payload,
      }
    case LICENSE_DATA_REQUEST_ASYNC.CANCEL:
      return {
        ...state,
        licenseLoader: false,
      }
    case TOGGLE_ADDON_TO_UNLOCK: {
      const selectedAddonsToUnlock = state.selectedAddonsToUnlock.includes(action.payload.addon)
        ? state.selectedAddonsToUnlock.filter((addon) => addon !== action.payload.addon)
        : [...state.selectedAddonsToUnlock, action.payload.addon]
      return { ...state, selectedAddonsToUnlock }
    }
    case RESET_SELECTED_ADDONS:
      return {
        ...state,
        selectedAddonsToUnlock: [],
      }
    case CREATE_ATO_INCIDENT_ASYNC.INITIATE:
      return {
        ...state,
        loader: true,
        error: null,
      }
    case CREATE_ATO_INCIDENT_ASYNC.SUCCESS:
      return {
        ...state,
        // no need to set loader false here
      }
    case CREATE_ATO_INCIDENT_ASYNC.ERROR:
      if (!createIncidentErrorCodes.includes(action.payload.error.status)) {
        return {
          ...state,
          loader: false,
          error: action.payload.error,
        }
      }
      return {
        ...state,
        loader: false,
      }
    case CREATE_ATO_INCIDENT_ASYNC.CANCEL:
      return {
        ...state,
        loader: false,
        error: null,
      }
    case SET_ALERT_ID:
      return {
        ...state,
        alertId: action.payload.alertId,
      }
    default:
      return state
  }
}
